import { render, staticRenderFns } from "./TransferCardItem.vue?vue&type=template&id=345642f4&scoped=true"
import script from "./TransferCardItem.vue?vue&type=script&lang=js"
export * from "./TransferCardItem.vue?vue&type=script&lang=js"
import style0 from "./TransferCardItem.vue?vue&type=style&index=0&id=345642f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345642f4",
  null
  
)

export default component.exports